export enum UserType {
  Undefined = 0,
  Admin = 1,
  User = 2
}
